import Material from '../../material'
import BindsProgressBar from './BindsProgressBar/BindsProgressBar'
import BindsProgressSpinner from './BindsProgressSpinner/BindsProgressSpinner'

export default Vue => {
  Material(Vue)
  Vue.component(BindsProgressBar.name, BindsProgressBar)
  Vue.component(BindsProgressSpinner.name, BindsProgressSpinner)
}
